
import { Component, Vue } from 'vue-property-decorator';
import { ErrorDialogPlugin } from '@/plugins/GlobalDialog';
import { ErrorDialogEvent } from '@/plugins/GlobalDialog/models/interfaces/ErrorDialogEvent';

@Component
export default class ErrorDialog extends Vue {
  private errors: string[] = [];
  private visible: boolean = false;
  private onConfirm: VoidFunction | false = false;

  private beforeMount(): void {
    ErrorDialogPlugin.$eventBus.$on('show-error-dialog', (params: ErrorDialogEvent) => {
      this.show(params.errors, params.onConfirm);
    });
  }

  private hide(): void {
    this.visible = false;
  }

  private confirm(): void {
    if (typeof this.onConfirm === 'function') {
      this.onConfirm();
    }

    this.hide();
  }

  private show(errors: string[], onConfirm?: VoidFunction): void {
    this.visible = true;
    this.errors = errors;

    if (onConfirm) {
      this.onConfirm = onConfirm;
    }
  }
}
